import { PostTitle, Abstract } from "../../../../src/components/Blog/Post/Metadata";
import { Paragraph, InlineCode, A, WideImage } from "../../../../src/components/Blog/Post/styles";
import Collapse from "../../../../src/components/Blog/Post/Collapse";
import Video from "../../../../src/components/Blog/Post/Video";
import Code from "../../../../src/components/Blog/Post/Code/Panel";
import * as React from 'react';
export default {
  PostTitle,
  Abstract,
  Paragraph,
  InlineCode,
  A,
  WideImage,
  Collapse,
  Video,
  Code,
  React
};